import type { MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';
import { useUpsertGdprConsentCategoriesMutation } from '@frameio/graphql-client/generated';
import { useCookieConsentLastUpdate } from '@frameio/segment/contexts';
import { getOneTrustConsentInput } from '@frameio/segment/utils/getOneTrustConsent';
import type { MeForAnalytics } from './useAnalytics';

export function useUpdateGdprConsent(me: MeForAnalytics) {
  const { cookieConsentLastUpdate } = useCookieConsentLastUpdate();

  const [upsertGdprConsentCategories] = useUpsertGdprConsentCategoriesMutation({
    context: {
      shouldIgnoreInvalidSharePassphraseError: true,
    },
  });

  const previousCategoryPreferences: MutableRefObject<string | undefined> =
    useRef(undefined);

  useEffect(() => {
    const oneTrustConsentInput = getOneTrustConsentInput();
    const isEdu = me?.isEdu;

    // For EDU users, override c0004 to false to restrict analytics
    if (isEdu && oneTrustConsentInput) {
      oneTrustConsentInput.c0004 = false;
    }

    if (
      me?.id &&
      oneTrustConsentInput &&
      previousCategoryPreferences.current !==
        JSON.stringify(oneTrustConsentInput)
    ) {
      previousCategoryPreferences.current =
        JSON.stringify(oneTrustConsentInput);
      upsertGdprConsentCategories({
        variables: {
          input: oneTrustConsentInput,
        },
        errorPolicy: 'all',
        ignoreResults: true,
      });
    }
  }, [cookieConsentLastUpdate, me, upsertGdprConsentCategories]);
}
